import React, { useEffect, useState } from "react";
import Nav from "../../pages/master/NavBar";
import { LoadingDiv, SweetAlertShow } from "../../pages/master/Master";
import { districtsList, statesList } from "../../api/Locations";
import { AdminBranchList, branchAdd, branchUpdate } from "../../api/AdminService";
import { useNavigate, useSearchParams } from "react-router-dom";
import Header from "../../pages/master/SideBar";
import TransferBranchLayout from "../../pages/branch/TransferBranchLayout";

export default function BranchAdd() {
  const [loading, setLoading] = useState(false);
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [data, setData] = useState({});
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const branchId = searchParams.get("id");
  const [filters, setFilters] = useState({
    name: "",
    status: "",
  });

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {

      const formData = new FormData(e.target);

      const response = branchId
        ? await branchUpdate(formData)
        : await branchAdd(formData);

      if (response.data.status) {

        SweetAlertShow(
          "success",
          "Success",
          response.data.message
        );

        navigate("/all/branch/list");

      } else {

        SweetAlertShow(
          "warning",
          "Warning",
          response.data.message
        );
      }

    } catch (error) {

      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message || error.message
      );

    } finally {

      setLoading(false);
    }
  };

  const getStates = async () => {
    setLoading(true);
    try {
      const response = await statesList();
      if (response.data.status === true) {
        setStates(response.data.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message
      );
    } finally {
      setLoading(false);
    }
  };

  const getDistricts = async (state = null) => {
    setLoading(true);
    try {
      let addUrl = "";
      if (state) addUrl += `&state=${state}`;
      const response = await districtsList(addUrl);
      if (response.data.status === true) {
        setDistricts(response.data.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message
      );
    } finally {
      setLoading(false);
    }
  };

  const getBranchDetails = async () => {
    if (!branchId) return;

    const response = await AdminBranchList(`id=${branchId}`);

    if (response.data.status) {
      setData(response.data.data || {});
    }
  };

  useEffect(() => {
    if (branchId) {
      getBranchDetails();
    }
  }, [branchId]);

  useEffect(() => {
    getStates();
    getDistricts();
  }, []);
  useEffect(() => {
    if (data?.state) {
      getDistricts(data?.state);
    }
  }, [data?.state]);

  return (
    <>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid mt-2">
                <div className="row">
                  <TransferBranchLayout />

                  <div className="col-12">
                    <div className="card">
                      <div className="card-body">
                        <form onSubmit={handleFormSubmit}>
                          <h4 className="text-primary">
                            {branchId ? "Update Branch" : "New Branch Add"}
                          </h4>
                          <input
                            type="hidden"
                            name="id"
                            value={branchId || ""}
                          />
                          <div className="row g-3">
                            <div className="col-sm-6">
                              <div className="form-floating form-floating-outline">
                                <input
                                  type="text"
                                  className="form-control input-lowercase"
                                  name="new_username"
                                  value={data?.username}
                                  onChange={(e) => setData({ ...data, username: e.target.value })}
                                  required
                                />
                                <label>Username</label>
                              </div>
                            </div>

                            <div className="col-sm-6">
                              <div className="form-floating form-floating-outline">
                                <input
                                  type="text"
                                  className="form-control input-uppercase"
                                  name="name"
                                  value={data?.name}
                                  onChange={(e) => setData({ ...data, name: e.target.value })}
                                  required
                                />
                                <label>Branch Name</label>
                              </div>
                            </div>

                            <div className="col-sm-6">
                              <div className="form-floating form-floating-outline">
                                <input
                                  type="number"
                                  className="form-control"
                                  name="mobile"
                                  value={data?.mobile}
                                  onChange={(e) => setData({ ...data, mobile: e.target.value })}
                                  required
                                />
                                <label>Mobile</label>
                              </div>
                            </div>

                            <div className="col-sm-6">
                              <div className="form-floating form-floating-outline">
                                <input
                                  type="email"
                                  className="form-control"
                                  name="email"
                                  value={data?.email}
                                  onChange={(e) => setData({ ...data, email: e.target.value })}
                                />
                                <label>Email</label>
                              </div>
                            </div>

                            <div className="col-sm-12">
                              <div className="form-floating form-floating-outline">
                                <input
                                  type="text"
                                  className="form-control input-uppercase"
                                  name="address"
                                  value={data?.address}
                                  onChange={(e) => setData({ ...data, address: e.target.value })}

                                />
                                <label>Address</label>
                              </div>
                            </div>

                            <div className="col-sm-4">
                              <div className="form-floating form-floating-outline">
                                <select
                                  name="state"
                                  id="state"
                                  className="form-select"
                                  value={data?.state}
                                  onChange={(e) =>
                                    setData({
                                      ...data,
                                      state: e.target.value,
                                    })
                                  }
                                >
                                  <option value="" selected disabled>
                                    Select State
                                  </option>
                                  {states?.map((state, i) => (
                                    <option key={i} value={state.name}>
                                      {state.name}
                                    </option>
                                  ))}
                                </select>

                                <label htmlFor="state">Select State</label>
                              </div>
                            </div>
                            <div className="col-sm-4">
                              <div className="form-floating form-floating-outline">
                                <select
                                  name="district"
                                  id="district"
                                  className="form-select"
                                  value={data?.district}
                                  onChange={(e) =>
                                    setData({
                                      ...data,
                                      district: e.target.value,
                                    })
                                  }
                                >
                                  <option value="" selected disabled>
                                    Select District
                                  </option>
                                  {districts?.map((district, i) => (
                                    <option value={district.name}>
                                      {district.name}
                                    </option>
                                  ))}
                                </select>

                                <label htmlFor="district">
                                  Select District
                                </label>
                              </div>
                            </div>

                            <div className="col-sm-4">
                              <div className="form-floating form-floating-outline">
                                <input
                                  type="number"
                                  className="form-control"
                                  name="pincode"
                                  value={data?.pincode}
                                  onChange={(e) => setData({ ...data, pincode: e.target.value })}


                                />
                                <label>Pincode</label>
                              </div>
                            </div>

                            <div className="col-sm-6">
                              <label>Institute Photo</label>
                              <input
                                type="file"
                                className="form-control"
                                name="school_photo"
                              />
                            </div>

                            <div className="col-sm-6">
                              <label>Institute Logo</label>
                              <input
                                type="file"
                                className="form-control"
                                name="school_logo"
                              />
                            </div>

                            <div className="col-12 d-flex justify-content-end mt-3">
                              <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={loading}
                              >
                                {loading ? (
                                  <>
                                    <span
                                      className="spinner-border spinner-border-sm me-2"
                                      role="status"
                                    ></span>
                                    Saving...
                                  </>
                                ) : (
                                  <>
                                    <i className={`me-1 ${branchId ? "ri-edit-line" : "ri-add-line"}`}></i>
                                    {branchId ? "Update" : "Create"}
                                  </>
                                )}
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
